<template>
  <div class="page-form">
    <div class="page-wrap"
         ref="demo"
         id="demo">
      <div class="page-head">
        <h3>服务申请表 Ι</h3>
        <p>（日本）</p>
      </div>
      <div class="page-body top-form">
        <i-form :label-width="120"
                label-position="right"
                class="label-font">
          <Row :gutter="10"
               :style="{marginTop: '30px'}">
            <i-col span="12">
              &nbsp;
            </i-col>
            <i-col span="12">
              <Form-item class="label-font"
                         label="Case#">
                <input class="flex"
                       type="text"
                       placeholder="由威马捷填写"
                       v-model="formData.case" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="12">
              <Form-item label="今后联系人">
                <input class="flex"
                       id="id1"
                       v-model="formData.jhlxr"
                       type="text" />
              </Form-item>
            </i-col>
            <i-col span="12">
              <Form-item label="与客户关系">
                <input class="flex"
                       id="id2"
                       v-model="formData.khgx"
                       type="text" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10"
               class-name="one-style">
            <i-col span="12">
              <Form-item label="电话">
                <input class="flex ivu-diy-input"
                       v-model="formData.dianhua"
                       id="id3"
                       type="number" />
              </Form-item>
            </i-col>
            <i-col span="12">
              <Form-item label="Email">
                <input class="flex"
                       id="id4"
                       v-model="formData.email"
                       type="text" />
              </Form-item>
            </i-col>
          </Row>
        </i-form>
        <p class="page-note"
           style="margin-bottom:30px;margin-top:0;">
          <span>与今后联系人无法取得联系时，有可能与紧急联系人联系。</span>
        </p>
      </div>
      <div class="page-title">
        客户信息
        <i>*</i>
      </div>
      <i-form :label-width="120"
              label-position="right"
              class="label-font">
        <div class="page-body client-body">
          <Row :gutter="10"
               :style="{marginTop: '30px'}"
               class-name="khxxName">
            <i-col span="8"
                   class-name="khxxNameipt1">
              <Form-item label="姓名">
                <input v-model="formData.formName"
                       class="form-in-input"
                       type="text"
                       id="id9"
                       ref="xmv"
                       placeholder="汉字" />
              </Form-item>
            </i-col>
            <i-col span="6"
                   class-name="khxxNameipt2">
              <input v-model="formData.formPY"
                     class="form-in-input"
                     type="text"
                     ref="py"
                     id="id10"
                     placeholder="拼音" />
            </i-col>
            <i-col span="10"
                   class-name="khxxNameipt3">
              <input class="form-in-input"
                     type="text"
                     :style="{width: '100%'}"
                     placeholder="由威马捷填写" />
            </i-col>
          </Row>
          <Row :gutter="10" style="display: flex;margin-bottom: 15px;">
            <div style="display: flex;width: 100%;justify-content: space-between;padding-right: 10px;">

               <span :style="{fontSize: '18px', fontWeight: 'bold'}"
                     class="sex_span"
                     style="width: 100px;vertical-align: middle; margin-left:15px;float: left;height: 42px;line-height: 42px;">性别</span>
              <RadioGroup v-model="formData.sex"
                          id="id11"
                          style="paddingTop: 3px;font-size:14px;width: 200px;float: left;">
                <Radio :label="1">男性</Radio>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Radio :label="2"
                       style="margin-left:13px;">女性</Radio>
              </RadioGroup>
              <div style="vertical-align: middle;float: left;">
                  <span :style="{fontSize: '18px', fontWeight: 'bold'}"
                        class="span_guoji"
                        style="width: 100px;float: left;vertical-align: middle; margin-left:15px;display: inline-block;height: 42px;line-height: 42px;">国籍</span>
                <Radio-group v-model="formData.gj1"
                             @on-change="clear_input($event, 'gjt')"
                             class="span_radio"
                             style="vertical-align: middle;margin-left:40px;float: left;">
                  <Radio :label="1">中国</Radio>
                  <Radio :label="2"
                         style="margin-left:35px;">其它</Radio>
                </Radio-group>
                <input type="text"
                       id="id12"
                       :disabled="gj1 === 1"
                       class="gjselect ivu-diy-input"
                       style="width: 350px;height: 40px;margin-left:24px;"
                       ref="gjt"
                       placeholder="请输入国籍"
                       v-model="formData.gjt" />
              </div>
            </div>
          </Row>
          <Row :gutter="10"
               class-name="khxxtimephone">
            <i-col span="8"
                   class-name="dateTime">
              <Form-item label="出生日期">
                <Date-picker type="date"
                             v-model="formData.cxrq"
                             id="id14"
                             :options="{
                                disabledDate (date) {
                                    return date && date.valueOf() > Date.now();
                                }
                            }"
                             placeholder="选择日期"></Date-picker>
              </Form-item>
            </i-col>
            <div style="float: left;">
              <Form-item label="身高" style="float: left;">
                <div style="display: flex;">
                  <input type="number"
                         class="shengao ivu-diy-input"
                         style="width: 220px;"
                         ref="sg"
                         id="id15"
                         placeholder="cm"
                         v-model="formData.sg" />cm
                </div>
              </Form-item>
              <Form-item label="体重" style="float: left;">
                <div style="display: flex;">
                  <input type="number"
                         class="shengao ivu-diy-input"
                         style="width: 220px;"
                         ref="tz"
                         id="id16"
                         placeholder="kg"
                         v-model="formData.tz" />kg
                </div>
              </Form-item>
            </div>
          </Row>
          <!--<Row :gutter="10"-->
          <!--class-name="khxxtimephone"-->
          <!--&gt;-->
          <!--<i-col span="8"-->
          <!--style="float: left;"-->
          <!--class-name="dateTime">-->
          <!--<Form-item label="出生日期">-->
          <!--<Date-picker type="date"-->
          <!--v-model="cxrq"-->
          <!--placeholder="选择日期"></Date-picker>-->
          <!--</Form-item>-->
          <!--</i-col>-->
          <!--<div style="float: left;">-->
          <!--<Form-item label="身高" style="float: left;">-->
          <!--<div style="display: flex;">-->
          <!--<input type="text"-->
          <!--ref="sg"-->
          <!--placeholder="cm" />cm-->
          <!--</div>-->
          <!--</Form-item>-->
          <!--<Form-item label="体重" style="float: left;">-->
          <!--<div style="display: flex;">-->
          <!--<input type="text"-->
          <!--ref="tz"-->
          <!--placeholder="kg" />kg-->
          <!--</div>-->
          <!--</Form-item>-->
          <!--</div>-->
          <!--</Row>-->
          <Row :gutter="10"
               class-name="khxxtimephone">
            <i-col span="11"
                   class-name="phone">
              <Form-item label="电话号码">
                <input type="number"
                       id="id17"
                       ref="dhhm"
                       class="flex ivu-diy-input"
                       v-model="formData.dhhm" />
              </Form-item>
            </i-col>
            <i-col span="13"
                   class-name="Email">
              <Form-item label="E-mail">
                <input type="text"
                       v-model="formData.email2"
                       id="id5"
                       ref="emailt"
                       class="flex" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10"
               class-name="khxxRess">
            <i-col span="16"
                   class-name="khxxRessipt">
              <Form-item label="现居住地址">
                <input type="text"
                       ref="xjzd"
                       id="id19"
                       placeholder="详细填写到门牌号码"
                       class="flex"
                       v-model="formData.xjzd" />
              </Form-item>
            </i-col>
            <i-col span="8">
              <Form-item label="　　　邮编">
                <input type="number"
                       ref="ybx"
                       id="id20"
                       class="flex ivu-diy-input"
                       v-model="formData.ybx"/>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10"
               class-name="khxxRess">
            <i-col span="16"
                   class-name="khxxRessipt">
              <Form-item label="资料邮寄地址">
                <input type="text"
                       ref="zlyjdz"
                       id="id21"
                       placeholder="详细填写到门牌号码"
                       class="flex"
                       v-model="formData.zlyjdz"/>
              </Form-item>
            </i-col>
            <i-col span="8">
              <Form-item label="　　　邮编">
                <input type="number"
                       ref="ybz"
                       id="id22"
                       class="flex ivu-diy-input"
                       v-model="formData.ybz" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10" class-name="khxxtimephone">
            <i-col span="12"
                   class="phone-email">
              <Form-item label="收件人">
                <input type="text"
                       style="width:330px;"
                       ref="sjr"
                       id="id23"
                       class="flex ivu-diy-input"
                       placeholder="收件人"
                       v-model="formData.sjr" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class="phone-email">
              <Form-item label="电话"
                         class="email">
                <input type="number"
                       style="width:389px"
                       ref="sjrdh"
                       id="id24"
                       class="flex shengao ivu-diy-input"
                       placeholder="电话"
                       v-model="formData.sjrdh"/>
              </Form-item>
            </i-col>
          </Row>
          <!--<Row :gutter="10"-->
          <!--class-name="khxxRess abc">-->
          <!--<i-col span="12">-->
          <!--<Form-item label="收件人">-->
          <!--<input type="text"-->
          <!--class="flex"-->
          <!--placeholder="收件人"-->
          <!--ref="sjr"/>-->
          <!--</Form-item>-->
          <!--</i-col>-->
          <!--<i-col span="12">-->
          <!--<Form-item label="电话">-->
          <!--<input type="number"-->
          <!--class="flex"-->
          <!--placeholder="电话"-->
          <!--ref="sjrdh" />-->
          <!--</Form-item>-->
          <!--</i-col>-->
          <!--</Row>-->
          <Row :gutter="10"
               class-name="khxxMuy">
            <i-col span="11"
                   class-name="Muy">
              <Form-item label="母语">
                <!-- <Radio-group :model.sync="form.country">
                                    <Radio value="cn">中文</Radio>
                                    <Radio value="other">其它</Radio>
                                </Radio-group> -->
                <RadioGroup v-model="formData.my1" @on-change="clear_input($event, 'myt')">
                  <Radio :label="1">中文</Radio>
                  <Radio :label="2">其它</Radio>
                </RadioGroup>
                <input type="text"
                       id="id25"
                       :disabled="my1 === 1"
                       style="width:189px"
                       ref="myt"
                       placeholder="请输入母语"
                       v-model="formData.myt" />
              </Form-item>
            </i-col>
            <i-col span="13">
              <Row :gutter="10">
                <i-col span="11"
                       :style="{textAlign: 'center'}"
                       style="paddingTop: 10px">
                  <b class="font-label">医疗/生活等的支付限额</b>
                </i-col>
                <i-col span="8">
                  <input class="form-in-input flex"
                         ref="zfxe"
                         id="id27"
                         type="number"
                         v-model="formData.zfxe" />
                </i-col>
                <i-col span="5"
                       style="paddingTop: 10px">
                  <b class="font-label">万人民币</b>
                </i-col>
              </Row>
            </i-col>
          </Row>

        </div>
        <div class="page-row">
          <div class="page-title"
               style="width:45%;float: left;">
            咨询目的
            <i>*</i>
          </div>
          <div class="page-title"
               style="width:50%;float: left;">
            申请服务
            <i>*</i>
          </div>
        </div>
        <div class="page-body">
          <div class="page-row page-cross">
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       ref="zxmd1"
                       id="id28"
                       value="zl"
                       v-model="formData.zxmd"
                       name="target" />治疗
              </label>
            </div>
            <div class="page-column" style="float: right;">
              <div>
                <label>
                  <input type="radio"
                         id="id29"
                         :disabled="formData.zxmd !== 'zl'"
                         ref="sqfw1"
                         name="service"
                         value="1"
                         v-model="formData.sqfw" />治疗服务A套餐（含医疗居留签证身份担保）
                </label>
              </div>
              <br/>
              <div>
                <label>
                  <input type="radio"
                         ref="sqfw2"
                         :disabled="formData.zxmd !== 'zl'"
                         name="service"
                         value="2"
                         v-model="formData.sqfw" />治疗服务B套餐（不含医疗居留签证身份担保）
                </label>
              </div>
            </div>
          </div>
          <div class="page-row page-cross">
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       value="jc"
                       v-model="formData.zxmd"
                       ref="zxmd2"
                       name="target" />检查
              </label>
            </div>
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       :checked="formData.zxmd === 'jc'"
                       :disabled="formData.zxmd !== 'jc'"
                       ref="sqfw3"
                       name="service"
                       value="3"
                       v-model="formData.sqfw" />检查服务C套餐
              </label>
            </div>
          </div>
          <div class="page-row page-cross">
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       value="dr"
                       v-model="formData.zxmd"
                       ref="zxmd3"
                       name="target" />第二诊疗意见
              </label>
            </div>
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       :disabled="formData.zxmd !== 'dr'"
                       :checked="formData.zxmd === 'dr'"
                       ref="sqfw4"
                       name="service"
                       value="4"
                       v-model="formData.sqfw" />第二诊疗意见D套餐
              </label>
            </div>
          </div>
          <div class="page-row page-cross">
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       ref="zxmd4"
                       v-model="formData.zxmd"
                       value="db"
                       name="target" />医疗签证身份担保
              </label>
            </div>
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       :checked="formData.zxmd === 'db'"
                       :disabled="formData.zxmd !== 'db'"
                       ref="sqfw5"
                       name="service"
                       value="5"
                       v-model="formData.sqfw" />医疗签证身份担保E套餐
              </label>
            </div>
          </div>
          <div class="page-row page-cross"
               style="padding:23px 0 26px 0!important;">
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       value="qt"
                       v-model="formData.zxmd"
                       ref="zxmd5"
                       v-on:change="changeSqfw"
                       name="target" />其它
              </label>
            </div>
            <div class="page-column" style="float: left;">
              <label>
                <input type="radio"
                       id="id30"
                       :checked="formData.zxmd === 'qt'"
                       :disabled="formData.zxmd !== 'qt'"
                       ref="sqfw6"
                       name="service"
                       value="6"
                       v-model="formData.sqfw" />其它服务 &nbsp;&nbsp;
                <input type="text"
                       class="form-in-input"
                       ref="sqfwt"
                       :disabled="formData.zxmd !== 'qt'"
                       style="width: 320px"
                       v-model="formData.sqfwt" />
              </label>
            </div>
          </div>
          <p class="page-note">
            <span>所有医疗翻译，原则上不能使用客户自己准备的翻译人员，需由我公司派遣医疗翻译。翻译费用由客户负担。</span>
          </p>
        </div>
        <div class="page-title">
          客户医疗信息
          <i>*</i>
        </div>
        <div class="page-body">
          <Row class-name="zdm">
            <i-col span="24"
                   style="margin-top:17px;padding-bottom:15px;border-bottom:1px dashed #e2e2e2;">
              <Form-item label="诊断名">
                <label class="label-with-radio">
                  <input type="radio"
                         id="id31"
                         ref="zdmY"
                         name="zdm"
                         value="1"
                         v-model="formData.zdmY" />有
                  <!--<i style="">*</i>-->
                </label>
                <input class="form-in-input"
                       type="text"
                       ref="zdmt"
                       name="zdmt"
                       style="width:600px;"
                       v-model="formData.zdmt" />
                <label class="label-with-radio">
                  <input type="radio"
                         ref="zdmW"
                         name="zdm"
                         value="0"
                         v-model="formData.zdmY" />无
                </label>
              </Form-item>
            </i-col>
          </Row>
          <div class="page-border"
               style="margin-bottom:28px!important;padding-bottom:33px;">
            <h4 class="page-stitle">希望接收的检查或治疗</h4>
            <p class="page-note">
              <span>请填写具体要求，比如希望接受的检查，部位等具体内容。(
                <i>*</i> 医院不保证根治，请谅解。)</span>

            </p>
            <textarea class="page-text" id="id33" ref="xwjczlt" v-model="formData.xwjczlt"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:10px;">
            <h4 class="page-stitle">希望咨询医院</h4>
            <p class="page-note">
              <span>咨询医院限3家以内，不可同时咨询，第一家接收客户时不再咨询第二家医院。</span>
            </p>
            <Row>
              <i-col span="24">
                <Row :gutter="10">
                  <i-col span="3">
                    <label class="label-with-radio">
                      <input type="radio"
                             id="id34"
                             ref="xwzxyyY"
                             value="1"
                             name="xwzxyy"
                             v-model="formData.xwzxyyY" />有
                    </label>
                  </i-col>
                  <i-col span="7">
                    <i-input type="text" v-model="formData.xwzxyy1" :disabled="xwzxyyDis">
                      <span slot="prepend">1</span>
                    </i-input>
                  </i-col>
                  <i-col span="7">
                    <i-input type="text" v-model="formData.xwzxyy2" :disabled="xwzxyyDis">
                      <span slot="prepend">2</span>
                    </i-input>
                  </i-col>
                  <i-col span="7">
                    <i-input type="text" v-model="formData.xwzxyy3" :disabled="xwzxyyDis">
                      <span slot="prepend">3</span>
                    </i-input>
                  </i-col>
                </Row>
              </i-col>
              <i-col span="24"
                     style="marginTop: 8px">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="xwzxyyW"
                         name="xwzxyy"
                         value="0"
                         v-model="formData.xwzxyyY" />无，希望根据医疗信息推荐
                </label>
              </i-col>
            </Row>
          </div>
          <div class="page-border"
               style="border:none;margin-bottom:28px;">
            <h4 class="page-stitle">希望就诊日期</h4>
            <p class="page-note">
              <span>1.翻译病历周期：约5个工作日 2.医院回复：约5个工作日（以实际回复时间为准）</span>
            </p>
            <Row :gutter="10">
              <i-col span="8">
                1 <DatePicker v-model="formData.xwjzrq1"
                              :options="{
                                disabledDate (date) {
                                    return date && date.valueOf() < Date.now() - 86400000;
                                }
                            }"
                              format="yyyy-MM-dd" type="date" placeholder="Select date" style="width: 200px" @on-change="xwjzrq1=$event"></DatePicker>
              </i-col>
              <i-col span="8">
                2 <DatePicker v-model="formData.xwjzrq2"
                              :options="{
                                disabledDate (date) {
                                    return date && date.valueOf() < Date.now() - 86400000;
                                }
                            }"
                              format="yyyy-MM-dd" type="date" placeholder="Select date" style="width: 200px" @on-change="xwjzrq2=$event"></DatePicker>
              </i-col>

              <i-col span="8">
                <label class="label-with-radio"
                >
                  <input type="radio"
                         ref="xwjzrq"
                         id="id36"
                         name="xwjzr"
                         value="1"
                         v-model="formData.xwjzrq" />最快可预约日期
                </label>
              </i-col>
            </Row>
          </div>
        </div>
        <div class="page-title">
          客户医疗信息
          <i>*</i>
        </div>
        <div class="page-body">
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">请详细填写病情经过</h4>
            <p class="page-note">
              <span>请按照时间顺序，写明最初发病的时间和症状以及从发病到现在为止做过的检查和治疗。</span>
              <br />1.化疗，请写明每次化疗的起止日期、化疗药物、用量、化疗反应等。
              <br />2.放疗，请写明每次放疗的起止日期，线量以及线量分布图。
              <br />3.是否做过基因检测？如有请提供检查报告书。
            </p>
            <textarea class="page-text" id="id37" style="min-height: 550px;"
                      ref="bqjg1" v-model="formData.bqjg1"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">目前有什么症状？</h4>
            <p class="page-note">
              <span> 如疼痛，乏力等。</span>
            </p>
            <textarea class="page-text" id="id38" ref="mqzk1" v-model="formData.mqzk1"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">国内医生关于今后的治疗建议和具体方案是什么？</h4>
            <p class="page-note">
              <span>如今后需要化疗，请写明还要做几次、每次日期、药物、用量等。</span>
            </p>
            <textarea class="page-text" id="id39" ref="jtfa1" v-model="formData.jtfa1"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">现在开始到出国前在国内是否还有其他检查？</h4>
            <p class="page-note">
              <span> 具体检查时间和内容等。</span>
            </p>
            <textarea class="page-text" id="id40" ref="qtjc1" v-model="formData.qtjc1"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">现在开始到出国前在国内是否还有其他治疗？</h4>
            <p class="page-note">
              <span>下次治疗的日期、药物、用量等。</span>
            </p>
            <textarea class="page-text" id="id41" ref="qtzl1" v-model="formData.qtzl1"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">目前服用的药物名称以及用药情况（如每片含量、一天几次、一次几片、早中晚饭前还是饭后等）</h4>
            <p class="page-note">
              <span>其它疾病，如高血压糖尿病等也要填写。出国时需要携带这些药物的包装盒，出国前如果服用的药物发生变化请及时通知我公司。</span>
            </p>
            <textarea class="page-text" id="id42" ref="yyqk1" v-model="formData.yyqk1"></textarea>
          </div>
          <div class="page-border"
               style="padding-bottom:32px; margin-bottom:40px;">
            <h4 class="page-stitle">可提供的DICOM电子版影像资料</h4>
            <p class="page-note">
              <span>请分别列出检查时间和检查项目。</span>
            </p>
            <textarea class="page-text" id="id43" ref="yxzl1" v-model="formData.yxzl1"></textarea>
          </div>
        </div>
        <div class="page-title">
          辅助信息
          <i>*</i>
        </div>
        <div class="page-body auxiliary">
          <div class="page-border">
            <Row>
              <i-col :span="6">
                <h4 class="page-stitle">客户是否有其它病史？</h4>
              </i-col>
              <i-col :span="18">
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="qtbsY"
                           id="id41"
                           name="qtbs"
                           value="1"
                           @click="formData.qtbstDis = false;"
                           v-model="formData.qtbsY" />有
                  </label>
                  <input class="form-in-input"
                         ref="qtbst"
                         :disabled="formData.qtbstDis"
                         type="text"
                         v-model="formData.qtbst" />
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="qtbsW"
                           name="qtbs"
                           @click="formData.qtbst = ''; formData.qtbstDis = true;"
                           value="0"
                           v-model="formData.qtbsY" />无
                  </label>
                </p>
              </i-col>
            </Row>
          </div>
          <div class="page-border">
            <Row>
              <i-col :span="6">
                <h4 class="page-stitle">客户现在是否有感染？</h4>
              </i-col>
              <i-col :span="18">
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="jfgrY"
                           id="id43"
                           name="jfgr"
                           @click="formData.jfgrDis = false;"
                           value="1"
                           v-model="formData.jfgrY" />有
                  </label>
                  <input class="form-in-input"
                         ref="jfgrt"
                         :disabled="formData.jfgrDis"
                         type="text"
                         v-model="formData.jfgrt" />
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="jfgrW"
                           name="jfgr"
                           @click="formData.jfgrt = '';formData.jfgrDis = true;"
                           value="0"
                           v-model="formData.jfgrY" />无
                  </label>
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="jfgrB"
                           name="jfgr"
                           value="2"
                           v-model="formData.jfgrY" />不知道
                  </label>
                </p>
              </i-col>
            </Row>
          </div>
          <div class="page-border">
            <Row>
              <i-col :span="6">
                <h4 class="page-stitle">客户现在是否有开放性伤口？</h4>
              </i-col>
              <i-col :span="18">
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kfnskY"
                           id="id45"
                           name="kfnsk"
                           value="1"
                           @click="formData.kfnsktDis = false;"
                           v-model="formData.kfnskY" />有
                  </label>
                  <input class="form-in-input"
                         ref="kfnskt"
                         :disabled="formData.kfnsktDis"
                         type="text"
                         v-model="formData.kfnskt" />
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kfnskW"
                           name="kfnsk"
                           value="1"
                           @click="formData.kfnskt = '';formData.kfnsktDis = true;"
                           v-model="formData.kfnskY" />无
                  </label>
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kfnskB"
                           name="kfnsk"
                           value="2"
                           v-model="formData.kfnskY" />不知道
                  </label>
                </p>
              </i-col>
            </Row>
          </div>
          <div class="page-border">
            <Row>
              <i-col :span="6">
                <h4 class="page-stitle">客户是否有过敏史？</h4>
              </i-col>
              <i-col :span="18">
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kgmsY"
                           id="id47"
                           name="kgms"
                           value="1"
                           @click="formData.kgmstDis = false;"
                           v-model="formData.kgmsY" />有
                  </label>
                  <input class="form-in-input"
                         ref="kgmst"
                         :disabled="formData.kgmstDis"
                         type="text"
                         v-model="formData.kgmst" />
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kgmsW"
                           name="kgms"
                           value="0"
                           @click="formData.kgmst = '';formData.kgmstDis = true;"
                           v-model="formData.kgmsY" />无
                  </label>
                </p>
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kgmsB"
                           name="kgms"
                           value="2"
                           v-model="formData.kgmsY" />不知道
                  </label>
                </p>
              </i-col>
            </Row>
          </div>
          <div class="page-border tb">
            <Row>
              <i-col :span="6">
                <h4 class="page-stitle">客户本人是否了解病情？</h4>
              </i-col>
              <i-col :span="18">
                <p>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kljbqL"
                           id="id48"
                           name="info5"
                           value="1"
                           v-model="formData.kljbqL" />了解
                  </label>
                  <label class="label-with-radio">
                    <input type="radio"
                           ref="kljbqB"
                           name="info5"
                           value="0"
                           v-model="formData.kljbqL" />不了解
                  </label>
                </p>
              </i-col>
            </Row>
          </div>
          <div class="page-border">
            <h4 class="page-stitle">客户目前是否可以乘机，独立行动？</h4>
            <p class="page-note">
              <span>如有腹水或脑水肿等，有可能不能坐飞机的，详情请咨询国内主治医生。</span>
            </p>
            <Row class="page-line">
              <i-col :span="2">
                <h4 class="page-stitle">乘机：</h4>
              </i-col>
              <i-col :span="3">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kcjK"
                         id="id49"
                         name="info6"
                         value="1"
                         v-model="formData.kcjK" />可以
                </label>
              </i-col>
              <i-col :span="5">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kcjB"
                         id="id50"
                         name="info6"
                         value="0"
                         v-model="formData.kcjK" />不可以
                </label>
              </i-col>
              <i-col :span="14">
                <input type="text"
                       class="form-in-input flex"
                       ref="kcjt"
                       placeholder="详情"
                       v-model="formData.kcjt" />
              </i-col>
            </Row>
            <Row class="page-line">
              <i-col :span="2">
                <h4 class="page-stitle">步行：</h4>
              </i-col>
              <i-col :span="3">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kbxD"
                         id="id51"
                         name="info7"
                         value="1"
                         v-model="formData.kbxD" />独立
                </label>
              </i-col>
              <i-col :span="5">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kbxX"
                         id="id52"
                         name="info7"
                         value="0"
                         v-model="formData.kbxD" />需要帮助
                </label>
              </i-col>
              <i-col :span="14">
                <input type="text"
                       class="form-in-input flex"
                       ref="kbxt"
                       placeholder="详情"
                       v-model="formData.kbxt" />
              </i-col>
            </Row>
            <Row class="page-line">
              <i-col :span="2">
                <h4 class="page-stitle">坐姿：</h4>
              </i-col>
              <i-col :span="3">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kzzD"
                         id="id53"
                         name="info8"
                         value="1"
                         v-model="formData.kzzD" />独立
                </label>
              </i-col>
              <i-col :span="5">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kzzX"
                         id="id54"
                         name="info8"
                         value="0"
                         v-model="formData.kzzD" />需要帮助
                </label>
              </i-col>
              <i-col :span="14">
                <input type="text"
                       class="form-in-input flex"
                       ref="kzzt"
                       placeholder="详情"
                       v-model="formData.kzzt" />
              </i-col>
            </Row>
            <Row class="page-line">
              <i-col :span="2">
                <h4 class="page-stitle">饮食：</h4>
              </i-col>
              <i-col :span="3">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kysD"
                         id="id55"
                         name="info9"
                         value="1"
                         v-model="formData.kysD"/>独立
                </label>
              </i-col>
              <i-col :span="5">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kysX"
                         id="id56"
                         name="info9"
                         value="0"
                         v-model="formData.kysD" />需要帮助
                </label>
              </i-col>
              <i-col :span="14">
                <input type="text"
                       class="form-in-input flex"
                       ref="kyst"
                       placeholder="详情"
                       v-model="formData.kyst" />
              </i-col>
            </Row>
            <Row class="page-line"
                 style="margin-bottom:0;">
              <i-col :span="2">
                <h4 class="page-stitle">排泄：</h4>
              </i-col>
              <i-col :span="3">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kpxD"
                         id="id57"
                         name="info10"
                         value="1"
                         v-model="formData.kpxD" />独立
                </label>
              </i-col>
              <i-col :span="5">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="kpxX"
                         id="id58"
                         name="info10"
                         value="0"
                         v-model="formData.kpxD" />需要帮助
                </label>
              </i-col>
              <i-col :span="14">
                <input type="text"
                       class="form-in-input flex"
                       ref="kpxt"
                       placeholder="详情"
                       v-model="formData.kpxt" />
              </i-col>
            </Row>
          </div>
          <div>
            <h4 class="page-stitle"
                style="margin:27px 0 18px 0;">海外就医时，是否有陪同人员？</h4>
            <Row class="page-line tas">
              <i-col :span="2">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryY"
                         id="id60"
                         name="yptry"
                         value="1"
                         @click="formData.yptryDis = false"
                         v-model="formData.yptryY" />有
                </label>
              </i-col>
              <i-col :span="7">
                <input class="form-in-input"
                       type="text"
                       id="id61"
                       ref="yptryxm1"
                       v-model="formData.fr_name"
                       :disabled="formData.yptryDis"
                       placeholder="姓名" />
              </i-col>
              <i-col :span="7">
                <input class="form-in-input"
                       type="text"
                       ref="yptrygx1"
                       :disabled="formData.yptryDis"
                       placeholder="关系"
                       v-model="formData.yptrygx1" />
              </i-col>
              <i-col :span="8">
                是否需要医疗签证：
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryS1"
                         :disabled="formData.yptryDis"
                         name="info61"
                         value="1"
                         v-model="formData.yptryS1" />是
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryF1"
                         :disabled="formData.yptryDis"
                         name="info61"
                         value="0"
                         v-model="formData.yptryS1" />否
                </label>
              </i-col>
            </Row>
            <Row class="page-line tas">
              <i-col :span="7"
                     :offset="2">
                <input class="form-in-input"
                       type="text"
                       v-model="formData.fr_name2"
                       ref="yptryxm2"
                       id="id62"
                       :disabled="formData.yptryDis"
                       placeholder="姓名" />
              </i-col>
              <i-col :span="7">
                <input class="form-in-input"
                       type="text"
                       ref="yptrygx2"
                       :disabled="formData.yptryDis"
                       placeholder="关系"
                       v-model="formData.yptrygx2" />
              </i-col>
              <i-col :span="8">
                是否需要医疗签证：
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryS2"
                         :disabled="formData.yptryDis"
                         name="info62"
                         value="1"
                         v-model="formData.yptryS2" />是
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryF2"
                         :disabled="formData.yptryDis"
                         name="info62"
                         value="0"
                         v-model="formData.yptryS2" />否
                </label>
              </i-col>
            </Row>
            <Row class="page-line tas">
              <i-col :span="7"
                     :offset="2">
                <input class="form-in-input"
                       type="text"
                       ref="yptryxm3"
                       id="id63"
                       v-model="formData.fr_name3"
                       :disabled="formData.yptryDis"
                       placeholder="姓名" />
              </i-col>
              <i-col :span="7">
                <input class="form-in-input"
                       type="text"
                       ref="yptrygx3"
                       :disabled="formData.yptryDis"
                       placeholder="关系"
                       v-model="formData.yptrygx3" />
              </i-col>
              <i-col :span="8">
                是否需要医疗签证：
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryS3"
                         :disabled="formData.yptryDis"
                         name="info63"
                         value="1"
                         v-model="formData.yptryS3" />是
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryF3"
                         :disabled="formData.yptryDis"
                         name="info63"
                         value="0"
                         v-model="formData.yptryS3" />否
                </label>
              </i-col>
            </Row>
            <Row class="page-line tas">
              <i-col :span="2">
                <label class="label-with-radio">
                  <input type="radio"
                         ref="yptryW"
                         @click="checkRadioHwjy()"
                         name="yptry"
                         value="0"
                         v-model="formData.yptryY" />无
                </label>
              </i-col>
            </Row>
          </div>
        </div>
        <!--<div class="page-body">-->
          <!--<div class="page-border">-->
            <!--<Row>-->
              <!--<i-col :span="6">-->
                <!--<h4 class="page-stitle">客户是否有其它病史？</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="18">-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--id="id44"-->
                           <!--name="qtbs"-->
                           <!--ref="qtbsY"-->
                           <!--class="radio-size"-->
                           <!--@click="qtbstDis = false;"-->
                           <!--value="1"-->
                           <!--v-model="formData.qtbsY" />有-->
                  <!--</label>-->
                  <!--<input class="form-in-input"-->
                         <!--type="text"-->
                         <!--ref="qtbst"-->
                         <!--:disabled="qtbstDis"-->
                         <!--style="width: 92%"-->
                         <!--v-model="formData.qtbst" />-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="qtbs"-->
                           <!--ref="qtbsW"-->
                           <!--class="radio-size"-->
                           <!--value="0"-->
                           <!--@click="formData.qtbst = ''; qtbstDis = true"-->
                           <!--v-model="formData.qtbsY" />无-->
                  <!--</label>-->
                <!--</p>-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
          <!--<div class="page-border">-->
            <!--<Row>-->
              <!--<i-col :span="6">-->
                <!--<h4 class="page-stitle">客户现在是否有感染？</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="18">-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="jfgr"-->
                           <!--ref="jfgrY"-->
                           <!--id="id46"-->
                           <!--@click="jfgrDis = false"-->
                           <!--class="radio-size"-->
                           <!--value="1"-->
                           <!--v-model="formData.jfgrY" />有-->
                  <!--</label>-->
                  <!--<input class="form-in-input"-->
                         <!--type="text"-->
                         <!--ref="jfgrt"-->
                         <!--:disabled="jfgrDis"-->
                         <!--style="width: 92%"-->
                         <!--v-model="formData.jfgrt" />-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="jfgr"-->
                           <!--ref="jfgrW"-->
                           <!--class="radio-size"-->
                           <!--value="0"-->
                           <!--@click="formData.jfgrt = '';jfgrDis = true;"-->
                           <!--v-model="formData.jfgrY" />无-->
                  <!--</label>-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="jfgr"-->
                           <!--ref="jfgrB"-->
                           <!--class="radio-size"-->
                           <!--value="2"-->
                           <!--v-model="formData.jfgrY" />不知道-->
                  <!--</label>-->
                <!--</p>-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
          <!--<div class="page-border">-->
            <!--<Row>-->
              <!--<i-col :span="6">-->
                <!--<h4 class="page-stitle">客户现在是否有开放性伤口？</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="18">-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="kfnsk"-->
                           <!--id="id48"-->
                           <!--ref="kfnskY"-->
                           <!--class="radio-size"-->
                           <!--value="1"-->
                           <!--@click="kfnsktDis = true;"-->
                           <!--v-model="formData.kfnskY" />有-->
                  <!--</label>-->
                  <!--<input class="form-in-input"-->
                         <!--type="text"-->
                         <!--ref="kfnskt"-->
                         <!--:disabled="kfnsktDis"-->
                         <!--style="width: 92%"-->
                         <!--v-model="formData.kfnskt" />-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="kfnsk"-->
                           <!--ref="kfnskW"-->
                           <!--class="radio-size"-->
                           <!--value="0"-->
                           <!--@click="formData.kfnskt = '';kfnsktDis = false;"-->
                           <!--v-model="formData.kfnskY" />无-->
                  <!--</label>-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="kfnsk"-->
                           <!--ref="kfnskB"-->
                           <!--value="2"-->
                           <!--class="radio-size"-->
                           <!--v-model="formData.kfnskY" />不知道-->
                  <!--</label>-->
                <!--</p>-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
          <!--<div class="page-border">-->
            <!--<Row>-->
              <!--<i-col :span="6">-->
                <!--<h4 class="page-stitle">客户是否有过敏史？</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="18">-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="kgms"-->
                           <!--id="id50"-->
                           <!--ref="kgmsY"-->
                           <!--class="radio-size"-->
                           <!--@click="kgmstDis = false;"-->
                           <!--value="1"-->
                           <!--v-model="formData.kgmsY" />有-->
                  <!--</label>-->
                  <!--<input class="form-in-input"-->
                         <!--type="text"-->
                         <!--ref="kgmst"-->
                         <!--:disabled="kgmstDis"-->
                         <!--style="width: 92%"-->
                         <!--v-model="formData.kgmst" />-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="kgms"-->
                           <!--ref="kgmsW"-->
                           <!--class="radio-size"-->
                           <!--value="0"-->
                           <!--@click="formData.kgmst = '';kgmstDis = true;"-->
                           <!--v-model="formData.kgmsY" />无-->
                  <!--</label>-->
                <!--</p>-->
                <!--<p>-->
                  <!--<label class="label-with-radio">-->
                    <!--<input type="radio"-->
                           <!--name="kgms"-->
                           <!--ref="kgmsB"-->
                           <!--class="radio-size"-->
                           <!--value="2"-->
                           <!--v-model="formData.kgmsY" />不知道-->
                  <!--</label>-->
                <!--</p>-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
          <!--<div class="page-border">-->
            <!--<Row :style="{paddingTop: '20px',paddingBottom: '42px'}">-->
              <!--<i-col :span="6">-->
                <!--<h4 class="page-stitle">客户本人是否了解病情？</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="18">-->
                <!--<p>-->
                  <!--<label>-->
                    <!--<input type="radio"-->
                           <!--name="kljbq"-->
                           <!--id="id52"-->
                           <!--ref="kljbqL"-->
                           <!--value="1"-->
                           <!--class="radio-size radio-sizes"-->
                           <!--v-model="formData.kljbqL" />了解-->
                  <!--</label>-->
                  <!--&nbsp;&nbsp;&nbsp;&nbsp;-->
                  <!--<label>-->
                    <!--<input type="radio"-->
                           <!--name="kljbq"-->
                           <!--ref="kljbqB"-->
                           <!--value="0"-->
                           <!--class="radio-size radio-sizes"-->
                           <!--v-model="formData.kljbqL" />不了解-->
                  <!--</label>-->
                <!--</p>-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
          <!--<div class="page-border"-->
               <!--style="padding-bottom:10px;">-->
            <!--<h4 class="page-stitle">客户目前是否可以乘机，独立行动？</h4>-->
            <!--<p class="page-note">-->
              <!--<span>如有腹水或脑水肿等，有可能不能坐飞机的，详情请咨询国内主治医生。</span>-->
            <!--</p>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="2">-->
                <!--<h4 class="page-stitle page-air">乘机：</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="3">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info6"-->
                         <!--ref="kcjK"-->
                         <!--id="id53"-->
                         <!--value="1"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kcjK" />可以-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="5">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info6"-->
                         <!--ref="kcjB"-->
                         <!--value="0"-->
                         <!--id="id54"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kcjK" />不可以-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="14">-->
                <!--<input type="text"-->
                       <!--class="form-in-input flex"-->
                       <!--ref="kcjt"-->
                       <!--placeholder="详情"-->
                       <!--v-model="formData.kcjt" />-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="2">-->
                <!--<h4 class="page-stitle page-air">步行：</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="3">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info7"-->
                         <!--ref="kbxD"-->
                         <!--id="id55"-->
                         <!--value="1"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kbxD" />独立-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="5">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info7"-->
                         <!--ref="kbxX"-->
                         <!--id="id56"-->
                         <!--value="0"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kbxD" />需要帮助-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="14">-->
                <!--<input type="text"-->
                       <!--class="form-in-input flex"-->
                       <!--ref="kbxt"-->
                       <!--id="id58"-->
                       <!--placeholder="详情"-->
                       <!--v-model="formData.kbxt" />-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="2">-->
                <!--<h4 class="page-stitle page-air">坐姿：</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="3">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info8"-->
                         <!--value="1"-->
                         <!--ref="kzzD"-->
                         <!--id="id57"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kzzD" />独立-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="5">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info8"-->
                         <!--ref="kzzX"-->
                         <!--id="id58"-->
                         <!--value="0"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kzzD" />需要帮助-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="14">-->
                <!--<input type="text"-->
                       <!--class="form-in-input flex"-->
                       <!--ref="kzzt"-->
                       <!--placeholder="详情"-->
                       <!--v-model="formData.kzzt" />-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="2">-->
                <!--<h4 class="page-stitle page-air">饮食：</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="3">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info9"-->
                         <!--ref="kysD"-->
                         <!--id="id59"-->
                         <!--value="1"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kysD" />独立-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="5">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info9"-->
                         <!--ref="kysX"-->
                         <!--id="id60"-->
                         <!--value="0"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kysD" />需要帮助-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="14">-->
                <!--<input type="text"-->
                       <!--class="form-in-input flex"-->
                       <!--ref="kyst"-->
                       <!--placeholder="详情"-->
                       <!--v-model="formData.kyst" />-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="2">-->
                <!--<h4 class="page-stitle page-air">排泄：</h4>-->
              <!--</i-col>-->
              <!--<i-col :span="3">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info10"-->
                         <!--ref="kpxD"-->
                         <!--id="id61"-->
                         <!--value="1"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kpxD" />独立-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="5">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info10"-->
                         <!--ref="kpxX"-->
                         <!--id="id62"-->
                         <!--value="0"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.kpxD" />需要帮助-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="14">-->
                <!--<input type="text"-->
                       <!--class="form-in-input flex"-->
                       <!--ref="kpxt"-->
                       <!--placeholder="详情"-->
                       <!--v-model="formData.kpxt" />-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
          <!--<div style="marginTop: 27px"-->
               <!--class="frjy">-->
            <!--<h4 class="page-stitle">赴日就医时，是否有陪同人员？</h4>-->
            <!--<Row class="page-line"-->
                 <!--style="marginTop: 30px">-->
              <!--<i-col :span="2">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="yptry"-->
                         <!--v-model="formData.frjy"-->
                         <!--value="1"-->
                         <!--ref="yptryY"-->
                         <!--id="id63"-->
                         <!--class="radio-size radio-sizeF" />有-->
                  <!--<i style="color: red">*</i>-->
                <!--</label>-->
              <!--</i-col>-->
              <!--<i-col :span="7">-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="yptryxm1"-->
                       <!--v-model="formData.fr_name"-->
                       <!--id="id65"-->
                       <!--:disabled="formData.frjy == '0'"-->
                       <!--placeholder="姓名" />-->
              <!--</i-col>-->
              <!--<i-col :span="7">-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="yptrygx1"-->
                       <!--:disabled="formData.frjy == '0'"-->
                       <!--placeholder="关系"-->
                       <!--v-model="formData.yptrygx1" />-->
              <!--</i-col>-->
              <!--<i-col :span="8">-->
                <!--<span class="form-font-size">是否需要医疗签证：</span>-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info61"-->
                         <!--:disabled="formData.frjy == '0'"-->
                         <!--ref="yptryS1"-->
                         <!--value="1"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.yptryS1" />是-->
                <!--</label>-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info61"-->
                         <!--:disabled="formData.frjy == '0'"-->
                         <!--ref="yptryF1"-->
                         <!--value="0"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.yptryS1" />否-->
                <!--</label>-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="7"-->
                     <!--:offset="2">-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="yptryxm2"-->
                       <!--id="id66"-->
                       <!--v-model="formData.fr_name2"-->
                       <!--:disabled="formData.frjy == '0'"-->
                       <!--placeholder="姓名" />-->
              <!--</i-col>-->
              <!--<i-col :span="7">-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="yptrygx2"-->
                       <!--:disabled="formData.frjy == '0'"-->
                       <!--placeholder="关系"-->
                       <!--v-model="formData.yptrygx2" />-->
              <!--</i-col>-->
              <!--<i-col :span="8">-->
                <!--<span class="form-font-size">是否需要医疗签证：</span>-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info62"-->
                         <!--:disabled="formData.frjy == '0'"-->
                         <!--ref="yptryS2"-->
                         <!--value="1"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.yptryS2" />是-->
                <!--</label>-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info62"-->
                         <!--:disabled="formData.frjy == '0'"-->
                         <!--ref="yptryF2"-->
                         <!--value="0"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--v-model="formData.yptryS2" />否-->
                <!--</label>-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="7"-->
                     <!--:offset="2">-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="yptryxm3"-->
                       <!--v-model="formData.fr_name3"-->
                       <!--:disabled="formData.frjy == '0'"-->
                       <!--placeholder="姓名" />-->
              <!--</i-col>-->
              <!--<i-col :span="7">-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="yptrygx3"-->
                       <!--:disabled="formData.frjy == '0'"-->
                       <!--placeholder="关系"-->
                       <!--v-model="formData.yptrygx3" />-->
              <!--</i-col>-->
              <!--<i-col :span="8">-->
                <!--<span class="form-font-size">是否需要医疗签证：</span>-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info63"-->
                         <!--ref="yptryS3"-->
                         <!--:disabled="formData.frjy == '0'"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--value="1"-->
                         <!--v-model="formData.yptryS3" />是-->
                <!--</label>-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="info63"-->
                         <!--ref="yptryF3"-->
                         <!--:disabled="formData.frjy == '0'"-->
                         <!--class="radio-size radio-sizeF"-->
                         <!--value="0"-->
                         <!--v-model="formData.yptryS3" />否-->
                <!--</label>-->
              <!--</i-col>-->
            <!--</Row>-->
            <!--<Row class="page-line">-->
              <!--<i-col :span="2">-->
                <!--<label class="label-with-radio">-->
                  <!--<input type="radio"-->
                         <!--name="yptry"-->
                         <!--v-model="formData.frjy"-->
                         <!--value="0"-->
                         <!--ref="yptryW"-->
                         <!--@click="yptryWClose()"-->
                         <!--class="radio-size radio-sizeF" />无-->
                <!--</label>-->
              <!--</i-col>-->
            <!--</Row>-->
          <!--</div>-->
        <!--</div>-->
        <div class="page-title">如有已经联系好的医院，请填写下列信息（任意填写）</div>
        <div class="page-body client-body">
          <div class="page-border"
               style="padding-bottom:16px;">
            <Row :gutter="10">
              <i-col span="24">
                <Form-item label="医院名称">
                  <input class="flex"
                         type="text"
                         v-model="formData.yymc"/>
                </Form-item>
              </i-col>
            </Row>

            <Row :gutter="10">
              <i-col span="12">
                <Form-item label="主治医生">
                  <input class="flex"
                         type="text"
                         v-model="formData.zzys" />
                </Form-item>
              </i-col>

              <i-col span="12">
                <Form-item label="诊疗室">
                  <input class="flex"
                         type="text"
                         v-model="formData.zls" />
                </Form-item>
              </i-col>

            </Row>


            <Row :gutter="10">
              <i-col span="12">
                <Form-item label="电话">
                  <input class="flex ivu-diy-input"
                         type="number"
                         v-model="formData.yydh" />
                </Form-item>
              </i-col>
              <i-col span="12">
                <Form-item label="E-mail">
                  <input class="flex"
                         v-model="formData.email4"
                         id="id7"
                         type="text" />
                </Form-item>
              </i-col>
            </Row>
            <Row :gutter="10">
              <i-col span="24">
                <Form-item label="初诊日期">
                  <input class="flex"
                         type="text"
                         style="width: 42%;float:left;"
                         v-model="formData.czrq" />
                </Form-item>
              </i-col>
            </Row>


            <Row :gutter="10">
              <i-col span="12">
                <Form-item label="联系人">
                  <input class="flex"
                         type="text"
                         v-model="formData.yylxr" />
                </Form-item>
              </i-col>
              <i-col span="12">
                <Form-item label="科室">
                  <input class="flex"
                         type="text"
                         v-model="formData.czks" />
                </Form-item>
              </i-col>
            </Row>
            <Row :gutter="10">
              <i-col span="12">
                <Form-item label="电话">
                  <input class="flex ivu-diy-input"
                         type="number"
                         v-model="formData.yydh1" />
                </Form-item>
              </i-col>
              <i-col span="12">
                <Form-item label="E-mail">
                  <input class="flex"
                         v-model="formData.email5"
                         id="id8"
                         type="text" />
                </Form-item>
              </i-col>
            </Row>
          </div>
          <div class="page-border"
               style="padding-bottom:32px;">
            <h4 class="page-stitle">检查治疗计划</h4>
            <textarea class="page-text" id="text1"
                      style="marginTop: 20px" v-model="formData.text1"></textarea>
          </div>
          <div style="marginTop: 28px;margin-bottom:20px;">
            <h4 class="page-stitle">医院是否同意在《医疗机关的受诊等计划证明书（医療機関による受診等予定証明書）》上盖章</h4>
            <Row :gutter="10"
                 style="marginTop: 10px">
              <i-col span="8">
                <label class="label-with-radio">
                  <input type="radio"
                         name="info777"
                         class="radio-size radio-sizeF"
                         value="1"
                         v-model="formData.info777" />同意
                </label>
              </i-col>
              <i-col span="8">
                <label class="label-with-radio">
                  <input type="radio"
                         name="info777"
                         value="0"
                         class="radio-size radio-sizeF"
                         v-model="formData.info777" />不同意
                </label>
              </i-col>
              <i-col span="8">
                <label class="label-with-radio">
                  <input type="radio"
                         name="info777"
                         value="2"
                         class="radio-size radio-sizeF"
                         v-model="formData.info777" />未确认
                </label>
              </i-col>
            </Row>
          </div>
        </div>
        <div class="page-title"
             style="margin-bottom:20px;">
          您是如何联系到我公司的？
          <i>*</i>
        </div>
        <div class="page-body LXcompany">
          <Row :gutter="10"
               class-name="LXradio">
            <i-col span="4">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs1"
                       id="id68"
                       name="info8"
                       v-model="formData.lxgs1" />病友介绍
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs2"
                       name="info8"
                       v-model="formData.lxgs2" />朋友介绍
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs3"
                       name="info8"
                       v-model="formData.lxgs3" />EAJ网站
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs4"
                       name="info8"
                       v-model="formData.lxgs4" />MAJ网站
              </label>
            </i-col>
            <i-col span="5">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs5"
                       name="info8"
                       v-model="formData.lxgs5" />威马捷中文网站
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs6"
                       name="info8"
                       v-model="formData.lxgs6" />外务省网站
              </label>
            </i-col>
            <i-col span="8">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       ref="lxgs7"
                       id="id69"
                       name="info8"
                       v-model="formData.lxgs7"/>医院介绍
                <i style="color: red">*</i>&nbsp;&nbsp;
                <input class="form-in-input"
                       type="text"
                       ref="lxgs7t"
                       style="width:55%;"
                       v-model="formData.lxgs7t"/>
              </label>
            </i-col>
            <i-col span="8">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       name="info8"
                       ref="lxgs8"
                       id="id70"
                       class="radio-size radio-sizeF"
                       v-model="formData.lxgs8" />医院网站
                <i style="color: red">*</i>&nbsp;&nbsp;
                <input class="form-in-input"
                       type="text"
                       ref="lxgs8t"
                       style="width:55%;"
                       v-model="formData.lxgs8t" />
              </label>
            </i-col>
            <i-col span="8">
              <label class="label-with-radio-1">
                <input type="checkbox"
                       name="info8"
                       ref="lxgs9"
                       id="id71"
                       class="radio-size radio-sizeF"
                       v-model="formData.lxgs9"/>其它
                <i style="color: red">*</i>&nbsp;&nbsp;
                <input class="form-in-input"
                       type="text"
                       ref="lxgs9t"
                       style="width:55%;"
                       v-model="formData.lxgs9t" />
              </label>
            </i-col>
          </Row>
          <!--<Row :gutter="10"-->
               <!--class-name="LXradio">-->
            <!--<i-col span="8">-->
              <!--<label class="label-with-radio-1">-->
                <!--<input type="checkbox"-->
                       <!--ref="lxgs7"-->
                       <!--id="id69"-->
                       <!--name="info8"-->
                       <!--v-model="formData.lxgs7"/>医院介绍-->
                <!--<i style="color: red">*</i>&nbsp;&nbsp;-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="lxgs7t"-->
                       <!--style="width:55%;"-->
                       <!--v-model="formData.lxgs7t"/>-->
              <!--</label>-->
            <!--</i-col>-->
            <!--<i-col span="8">-->
              <!--<label class="label-with-radio-1">-->
                <!--<input type="checkbox"-->
                       <!--name="info8"-->
                       <!--ref="lxgs8"-->
                       <!--id="id70"-->
                       <!--class="radio-size radio-sizeF"-->
                       <!--v-model="formData.lxgs8" />医院网站-->
                <!--<i style="color: red">*</i>&nbsp;&nbsp;-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="lxgs8t"-->
                       <!--style="width:55%;"-->
                       <!--v-model="formData.lxgs8t" />-->
              <!--</label>-->
            <!--</i-col>-->
            <!--<i-col span="8">-->
              <!--<label class="label-with-radio-1">-->
                <!--<input type="checkbox"-->
                       <!--name="info8"-->
                       <!--ref="lxgs9"-->
                       <!--id="id71"-->
                       <!--class="radio-size radio-sizeF"-->
                       <!--v-model="formData.lxgs9"/>其它-->
                <!--<i style="color: red">*</i>&nbsp;&nbsp;-->
                <!--<input class="form-in-input"-->
                       <!--type="text"-->
                       <!--ref="lxgs9t"-->
                       <!--style="width:55%;"-->
                       <!--v-model="formData.lxgs9t" />-->
              <!--</label>-->
            <!--</i-col>-->
          <!--</Row>-->
        </div>
        <div class="page-title">今后联系人为客户本人时，请指定紧急联系人</div>
        <div class="page-body last-from">
          <div class="page-border"
               style="margin-top:0;padding-bottom:20px;">
            <p class="page-note">
              <span>与今后联系人无法取得联系时，有可能与客户本人直接联系。</span>
            </p>
            <Row :gutter="10">
              <i-col span="12">
                <Form-item label="紧急联系人">
                  <input class="flex"
                         type="text"
                         v-model="formData.jjlxr" />
                </Form-item>
              </i-col>
              <i-col span="12">
                <Form-item label="与客户关系">
                  <input class="flex"
                         type="text"
                         v-model="formData.ykhgx" />
                </Form-item>
              </i-col>
              <i-col span="12">
                <Form-item label="电话">
                  <input class="flex ivu-diy-input"
                         type="number"
                         v-model="formData.khdh" />
                </Form-item>
              </i-col>
              <i-col span="12">
                <Form-item label="E-mail">
                  <input class="flex"
                         v-model="formData.email3"
                         id="id6"
                         type="text" />
                </Form-item>
              </i-col>
            </Row>
          </div>
          <div class="page-border">
            <p class="page-note"
               style="margin-bottom:0px!important;">
              <span>请详细填写上述全部内容，如没有详细填写，我公司有可能无法接受您的申请。</span>
            </p>
            <p class="page-note"
               style="margin-top:0px!important;">
              <span>填写的所有内容必须保证全部属实，如有虚假内容后果自负，本公司不承担任何责任。</span>
            </p>
          </div>
          <div>
            <p class="page-note"
               style="margin-bottom:0px!important;">
              <span>注意事项及免责声明</span>
            </p>
            <p class="page-state">1. 本公司不保证一定能治愈或一定能介绍到接收客户的医疗机构。</p>
            <p class="page-state">2. 本公司也不会对医疗机构的医疗失误及代叫的交通机关的事故等负任何责任。</p>
            <p class="page-state">3. 关于客户是否要出国接受治疗以及选择哪家医疗机构接受治疗，请客户自己决定。</p>
            <p class="page-state">
              4. 本公司只能在客户及医疗机关所提供的资料为正确资料的前提下才可提供服务。 因此被提供的资料不正确时，可能会出现无法决定治疗方针，不得不接受与当初设想不同的治疗方法等对应方式。
            </p>
            <p class="page-state">
              5. 来日后，在接受治疗以及检查时，如果发现有其它新的疾病和症状时，会产生其它费用。 如果没有办法支付追加费用时会中止所提供的各项服务。
            </p>
            <p class="page-state">6. 本项服务有可能由于天灾及战争等无法抗拒的灾难而无法提供或有部分服务接受限制。</p>
          </div>
        </div>
      </i-form>

    </div>
    <div class="text-center">
      <button class="btn"
              @click="submitNext">提交</button>
    </div>
  </div>
</template>
<script>
  import { verifyPhone, verifyEmail, verifyPassword } from "../../public/js/util.js";
  import * as apis from "@/api/other";
  import $ from "jquery";
  export default {
    data () {
      return {
        username: "",
        formName: '',
        formPY: '',
        form: {
          radio: "male",
          country: ""
        },
        id: 0,
        jhlxr: '',khgx: '',dianhua: '',email: '',email2: '', email3: '',email4: '', email5: '',
        xwzxyyDis: false, qtbstDis: false, jfgrDis: false, kfnsktDis: false, kgmstDis: false,

        sex: '', xmv: '', py: '', gj1: '', gjt: '', cxrq: '', sg: '', tz: '',
        dhhm: '', emailt: '', xjzd: '', ybx: '', zlyjdz: '', ybz: '', sjr: '', sjrdh: '',
        my1: '', myt: '', zfxe: '',
        zxmd1: '', zxmd2: '', zxmd3: '', zxmd4: '', zxmd5: '', zdmY: '', zdmW: '', zdmt: '',
        sqfw1: '', sqfw2: '', sqfw3: '', sqfw4: '', sqfw5: '', sqfw6: '', sqfwt: '',
        xwjczlt: '', xwzxyyY: '', xwzxyyW: '', xwzxyy1: '', xwzxyy2: '', xwzxyy3: '',
        xwjzrq: '', xwjzrq1: '', xwjzrq2: '', bqjg1: '', mqzk1: '', jtfa1: '', qtjc1: '',
        qtzl1: '', yyqk1: '', yxzl1: '', qtbsY: '', qtbsW: '', qtbst: '',
        jfgrY: '', jfgrW: '', jfgrB: '', jfgrt: '', kfnskY: '', kfnskW: '', kfnskB: '', kfnskt: '',
        kgmsY: '', kgmsW: '', kgmsB: '', kgmst: '', kljbqL: '', kljbqB: '', kbxt: '', kbxD: '', kbxX: '',
        kcjK: '', kcjB: '', kcjt: '', kzzt: '', kzzD: '', kzzX: '', kysD: '', kysX: '', kyst: '',
        kpxD: '', kpxX: '', kpxt: '', yptryW: '', yptryY: '',
        yptryxm1: '',yptrygx1: '', yptryS1: '', yptryF1: '',
        yptryxm2: '',yptrygx2: '', yptryS2: '', yptryF2: '',
        yptryxm3: '',yptrygx3: '', yptryS3: '', yptryF3: '',
        lxgs1: '', lxgs2: '', lxgs3: '', lxgs4: '', lxgs5: '', lxgs6: '', lxgs7: '', lxgs8: '', lxgs9: '',
        lxgs7t: '', lxgs8t: '', lxgs9t: '',zxmd: '', frjy: '',
        fr_name: '',
        fr_name2: '',
        fr_name3: '',
        formData: {}
      };
    },
    mounted () {
      let id = this.$route.params.hid;
      this.id = id;
      this.type = localStorage.getItem('hospital_type');
      //   this.getFormStep();

      let that = this;
      $("input[name='zdm']").on('change', function () {
        if (that.$refs.zdmY.checked) {
          $("input[name='zdmt']").prop('disabled', false);
        } else {
          that.$refs.zdmt.value = '';
          $("input[name='zdmt']").prop('disabled', true);
        }
      });
      $("input[name='xwzxyy']").on('change', function () {
        if (that.$refs.xwzxyyY.checked) {
          that.xwzxyyDis = false;
        } else {
          that.xwzxyy1 = '';
          that.xwzxyy2 = '';
          that.xwzxyy3 = '';
          that.xwzxyyDis = true;
        }
      });
      $("input[name='qtbs']").on('change', function () {
        if (that.$refs.qtbsY.checked) {
          that.qtbstDis = false;
        } else {
          that.$refs.qtbst.value = '';
          that.qtbstDis = true;
        }
      });
      $("input[name='jfgr']").on('change', function () {
        if (that.$refs.jfgrY.checked) {
          that.jfgrDis = false;
        } else {
          that.$refs.jfgrt.value = '';
          that.jfgrDis = true;
        }
      });
      $("input[name='kfnsk']").on('change', function () {
        if (that.$refs.kfnskY.checked) {
          that.kfnsktDis = false;
        } else {
          that.$refs.kfnskt.value = '';
          that.kfnsktDis = true;
        }
      });
      $("input[name='kgms']").on('change', function () {
        if (that.$refs.kgmsY.checked) {
          that.kgmstDis = false;
        } else {
          that.$refs.kgmst.value = '';
          that.kgmstDis = true;
        }
      });

    },
    methods: {
      changeSqfw () {
        if (this.formData.zxmd !== 'qt') {
          this.formData.sqfwt = '';
        }
      },
      clear_input(v, value) {
        if (v === 1) {
          this.$refs[value].value = '';
        }
      },
      yptryWClose() {
        this.formData.fr_name = ''
        this.formData.yptrygx1 = ''
        this.formData.yptryS1 = ''
        this.formData.fr_name2 = ''
        this.formData.yptrygx2 = ''
        this.formData.yptryS2 = ''
        this.formData.fr_name3 = ''
        this.formData.yptrygx3 = ''
        this.formData.yptryS3 = ''
        this.$refs.yptryxm1.value = ''
        this.$refs.yptrygx1.value = ''
        this.$refs.yptryxm2.value = ''
        this.$refs.yptrygx2.value = ''
        this.$refs.yptryxm3.value = ''
        this.$refs.yptrygx3.value = ''
        this.fr_name = ''
        this.fr_name2 = ''
        this.fr_name3 = ''
        this.$refs.yptryS1.checked = false;
        this.$refs.yptryF1.checked = false;
        this.$refs.yptryS2.checked = false;
        this.$refs.yptryF2.checked = false;
        this.$refs.yptryS3.checked = false;
        this.$refs.yptryF3.checked = false;
        this.$refs.yptryS1.disabled = true;
        this.$refs.yptryF1.disabled = true;
        this.$refs.yptryS2.disabled = true;
        this.$refs.yptryF2.disabled = true;
        this.$refs.yptryS3.disabled = true;
        this.$refs.yptryF3.disabled = true;
        console.log(123);
        console.log(this.$refs.yptryxm1);
      },
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString(), // 秒
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(
                 ret[1],
                 ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
            );
          }
        }
        return fmt;
      },
      async submitNext () {
        let arr = []
        let arr2 = [];
        if (!this.formData.jhlxr) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入今后联系人',

              duration: 5000
            });
          }, 0)
          arr2.push('id1');
          arr.push(false)
        }
        if (!this.formData.khgx) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入与客户关系',

              duration: 5000
            });
          }, 0)
          arr2.push('id2');
          arr.push(false)
        }
        if (!this.formData.dianhua) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入电话',

              duration: 5000
            });
          }, 0)
          arr2.push('id3');
          arr.push(false)
        }
        if (this.formData.email && !verifyEmail(this.formData.email)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '邮箱格式不正确！',

              duration: 5000
            });
          }, 0)
          arr2.push('id4');
          arr.push(false)
        }
        if (!this.formData.email) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入Email',

              duration: 5000
            });
          }, 0)
          arr2.push('id4');
          arr.push(false)
        }
        if (this.formData.email2 && !verifyEmail(this.formData.email2)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '邮箱格式不正确！',

              duration: 5000
            });
          }, 0)
          arr2.push('id5');
          arr.push(false)
        }
        if (!this.formData.email2) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入Email',

              duration: 5000
            });
          }, 0)
          arr2.push('id5');
          arr.push(false)
        }
        if (this.formData.email3 && !verifyEmail(this.formData.email3)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '邮箱格式不正确！',

              duration: 5000
            });
          }, 0)
          arr2.push('id6');
          arr.push(false)
        }

        if (this.formData.email4 && !verifyEmail(this.formData.email4)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '邮箱格式不正确！',

              duration: 5000
            });
          }, 0)
          arr2.push('id7');
          arr.push(false)
        }
        if (this.formData.email5 && !verifyEmail(this.formData.email5)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '邮箱格式不正确！',

              duration: 5000
            });
          }, 0)
          arr2.push('id8');
          arr.push(false)
        }
        if (!this.$refs.xmv.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入姓名',

              duration: 5000
            });
          }, 0)
          arr2.push('id9');
          arr.push(false)
        }
        if (!this.$refs.py.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入姓名拼音',

              duration: 5000
            });
          }, 0)
          arr2.push('id10');
          arr.push(false)
        }
        if (!this.formData.sex) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '性别未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id11');
          arr.push(false)
        }
        if (!this.formData.gj1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '国籍未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id12');
          arr.push(false)
        }
        if (this.formData.gj1 == 2 && !this.$refs.gjt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入国籍',

              duration: 5000
            });
          }, 0)
          arr2.push('id12');
          arr.push(false)
        }
        if (!this.formData.cxrq) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入出生日期',

              duration: 5000
            });
          }, 0)
          arr2.push('id14');
          arr.push(false)
        }
        if (!this.$refs.sg.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入身高',

              duration: 5000
            });
          }, 0)
          arr2.push('id15');
          arr.push(false)
        }
        if (!this.$refs.tz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入体重',

              duration: 5000
            });
          }, 0)
          arr2.push('id16');
          arr.push(false)
        }
        if (!this.$refs.dhhm.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入电话号码',

              duration: 5000
            });
          }, 0)
          arr2.push('id17');
          arr.push(false)
        }
        if (!this.$refs.emailt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入E-mail',

              duration: 5000
            });
          }, 0)
          arr2.push('id5');
          arr.push(false)
        }
        if (!this.$refs.xjzd.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入现居住地地址',

              duration: 5000
            });
          }, 0)
          arr2.push('id19');
          arr.push(false)
        }
        if (!this.$refs.ybx.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入现居住地地址邮编',

              duration: 5000
            });
          }, 0)
          arr2.push('id20');
          arr.push(false)
        }
        if (!this.$refs.zlyjdz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入资料邮寄地址',

              duration: 5000
            });
          }, 0)
          arr2.push('id21');
          arr.push(false)
        }
        if (!this.$refs.ybz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入资料邮寄地址邮编',

              duration: 5000
            });
          }, 0)
          arr2.push('id22');
          arr.push(false)
        }
        if (!this.$refs.sjr.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入收件人',

              duration: 5000
            });
          }, 0)
          arr2.push('id23');
          arr.push(false)
        }
        if (!this.$refs.sjrdh.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入收件人电话',

              duration: 5000
            });
          }, 0)
          arr2.push('id24');
          arr.push(false)
        }
        if (!this.formData.my1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '母语未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id25');
          arr.push(false)
        }
        if (this.formData.my1 == 2 && !this.$refs.myt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入母语',

              duration: 5000
            });
          }, 0)
          arr2.push('id26');
          arr.push(false)
        }
        if (!this.$refs.zfxe.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入医疗/生活等的支付限额',

              duration: 5000
            });
          }, 0)
          arr2.push('id27');
          arr.push(false)
        }
        if (!this.$refs.zxmd1.checked && !this.$refs.zxmd2.checked && !this.$refs.zxmd3.checked && !this.$refs.zxmd4.checked && !this.$refs.zxmd5.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '咨询目未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id28');
          arr.push(false)
        }
        if (!this.$refs.sqfw1.checked && !this.$refs.sqfw2.checked && !this.$refs.sqfw3.checked &&
             !this.$refs.sqfw4.checked && !this.$refs.sqfw5.checked && !this.$refs.sqfw6.checked
        ) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '申请服务未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id29');
          arr.push(false)
        }
        if (this.$refs.sqfw6.checked && !this.$refs.sqfwt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请填写申请服务其它服务',

              duration: 5000
            });
          }, 0)
          arr2.push('id30');
          arr.push(false)
        }
        if (!this.$refs.zdmY.checked && !this.$refs.zdmW.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '诊断名未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id31');
          arr.push(false)
        }
        if (this.$refs.zdmY.checked && !this.$refs.zdmt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入诊断名',

              duration: 5000
            });
          }, 0)
          arr2.push('id31');
          arr.push(false)
        }
        if (!this.$refs.xwjczlt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入希望接收的检查或治疗内容',

              duration: 5000
            });
          }, 0)
          arr2.push('id33');
          arr.push(false)
        }
        if (!this.$refs.xwzxyyY.checked && !this.$refs.xwzxyyW.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '希望咨询医院未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id34');
          arr.push(false)
        }
        if (this.$refs.xwzxyyY.checked && !this.formData.xwzxyy1 && !this.formData.xwzxyy2 && !this.formData.xwzxyy3){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入希望咨询医院',

              duration: 5000
            });
          }, 0)
          arr2.push('id34');
          arr.push(false)
        }
        if (!this.$refs.xwjzrq.checked && !this.formData.xwjzrq1 && !this.formData.xwjzrq2){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入希望就诊日期',

              duration: 5000
            });
          }, 0)
          arr2.push('id36');
          arr.push(false)
        }
        if (!this.$refs.bqjg1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入请详细填写病情经过',

              duration: 5000
            });
          }, 0)
          arr2.push('id37');
          arr.push(false)
        }
        if (!this.$refs.mqzk1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入目前有什么症状',

              duration: 5000
            });
          }, 0)
          arr2.push('id38');
          arr.push(false)
        }
        if (!this.$refs.jtfa1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入国内医生关于今后的治疗建议和具体方案是什么',

              duration: 5000
            });
          }, 0)
          arr2.push('id39');
          arr.push(false)
        }
        if (!this.$refs.qtjc1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入现在开始到出国前在国内是否还有其他检查',

              duration: 5000
            });
          }, 0)
          arr2.push('id40');
          arr.push(false)
        }
        if (!this.$refs.qtzl1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入现在开始到出国前在国内是否还有其他治疗',

              duration: 5000
            });
          }, 0)
          arr2.push('id41');
          arr.push(false)
        }
        if (!this.$refs.yyqk1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入目前服用的药物名称以及用药情况',

              duration: 5000
            });
          }, 0)
          arr2.push('id42');
          arr.push(false)
        }
        if (!this.$refs.yxzl1.value){
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入可提供的DICOM电子版影像资料',

              duration: 5000
            });
          }, 0)
          arr2.push('id43');
          arr.push(false)
        }
        if (!this.$refs.qtbsY.checked && !this.$refs.qtbsW.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户是否有其它病史未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id44');
          arr.push(false)
        }
        if (this.$refs.qtbsY.checked && !this.$refs.qtbst.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户是否有其它病史',

              duration: 5000
            });
          }, 0)
          arr2.push('id44');
          arr.push(false)
        }
        if (!this.$refs.jfgrY.checked && !this.$refs.jfgrW.checked && !this.$refs.jfgrB.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户现在是否有感染未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id46');
          arr.push(false)
        }
        if (this.$refs.jfgrY.checked && !this.$refs.jfgrt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入现在是否有感染未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id46');
          arr.push(false)
        }
        if (!this.$refs.kfnskY.checked && !this.$refs.kfnskW.checked && !this.$refs.kfnskB.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户现在是否有开放性伤口未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id48');
          arr.push(false)
        }
        if (this.$refs.kfnskY.checked && !this.$refs.kfnskt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户现在是否有开放性伤口',

              duration: 5000
            });
          }, 0)
          arr2.push('id48');
          arr.push(false)
        }
        if (!this.$refs.kgmsY.checked && !this.$refs.kgmsW.checked && !this.$refs.kgmsB.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户是否有过敏史未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id50');
          arr.push(false)
        }
        if (this.$refs.kgmsY.checked && !this.$refs.kgmst.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户是否有过敏史',

              duration: 5000
            });
          }, 0)
          arr2.push('id50');
          arr.push(false)
        }
        if (!this.$refs.kljbqL.checked && !this.$refs.kljbqB.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户本人是否了解病情未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id52');
          arr.push(false)
        }
        if (!this.$refs.kcjK.checked && !this.$refs.kcjB.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户乘机未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id53');
          arr.push(false)
        }
        if (this.$refs.kcjB.checked && !this.$refs.kcjt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户乘机描述',

              duration: 5000
            });
          }, 0)
          arr2.push('id54');
          arr.push(false)
        }
        if (!this.$refs.kbxD.checked && !this.$refs.kbxX.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户步行未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id55');
          arr.push(false)
        }
        if (this.$refs.kbxX.checked && !this.$refs.kbxt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户步行描述',

              duration: 5000
            });
          }, 0)
          arr2.push('id56');
          arr.push(false)
        }
        if (!this.$refs.kzzD.checked && !this.$refs.kzzX.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户坐姿未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id57');
          arr.push(false)
        }
        if (this.$refs.kzzX.checked && !this.$refs.kzzt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户坐姿描述',

              duration: 5000
            });
          }, 0)
          arr2.push('id58');
          arr.push(false)
        }
        if (!this.$refs.kysD.checked && !this.$refs.kysX.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户饮食未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id59');
          arr.push(false)
        }
        if (this.$refs.kysX.checked && !this.$refs.kyst.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户饮食描述',

              duration: 5000
            });
          }, 0)
          arr2.push('id60');
          arr.push(false)
        }
        if (!this.$refs.kpxD.checked && !this.$refs.kpxX.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '客户排泄未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id61');
          arr.push(false)
        }
        if (this.$refs.kpxX.checked && !this.$refs.kpxt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入客户排泄描述',

              duration: 5000
            });
          }, 0)
          arr2.push('id62');
          arr.push(false)
        }
        if (!this.$refs.yptryY.checked && !this.$refs.yptryW.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '赴日就医时，是否有陪同人员未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id63');
          arr.push(false)
        }
        if (this.$refs.yptryY.checked) {
          if (!this.$refs.yptryxm1.value && !this.$refs.yptrygx1.value) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: '请输入赴日就医时，是否有陪同人员姓名与关系',

                duration: 5000
              });
            }, 0)
            arr2.push('id63');
            arr.push(false)
          }
          if (!this.$refs.yptryxm1.value || this.$refs.yptrygx1.value){
            if (!this.$refs.yptryS1.checked && !this.$refs.yptryF1.checked) {
              setTimeout(() => {
                this.$message({
                  showClose: true,
                  message: '是否需要医疗签证未选择',

                  duration: 5000
                });
              }, 0)
              arr2.push('id63');
              arr.push(false)
            }
          }
          if (this.$refs.yptryxm2.value || this.$refs.yptrygx2.value){
            if (!this.$refs.yptryS2.checked && !this.$refs.yptryF2.checked) {
              setTimeout(() => {
                this.$message({
                  showClose: true,
                  message: '是否需要医疗签证未选择',

                  duration: 5000
                });
              }, 0)
              arr2.push('id63');
              arr.push(false)
            }
          }
          if (this.$refs.yptryxm3.value || this.$refs.yptrygx3.value){
            if (!this.$refs.yptryS3.checked && !this.$refs.yptryF3.checked) {
              setTimeout(() => {
                this.$message({
                  showClose: true,
                  message: '是否需要医疗签证未选择',

                  duration: 5000
                });
              }, 0)
              arr2.push('id63');
              arr.push(false)
            }
          }
        }
        if (
             !this.$refs.lxgs1.checked && !this.$refs.lxgs2.checked && !this.$refs.lxgs3.checked &&
             !this.$refs.lxgs4.checked && !this.$refs.lxgs5.checked && !this.$refs.lxgs6.checked &&
             !this.$refs.lxgs7.checked && !this.$refs.lxgs8.checked && !this.$refs.lxgs9.checked
        ) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '您是如何联系到我公司的未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id68');
          arr.push(false)
        }
        if (this.$refs.lxgs7.checked && !this.$refs.lxgs7t.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入医院介绍',

              duration: 5000
            });
          }, 0)
          arr2.push('id69');
          arr.push(false)
        }
        if (this.$refs.lxgs8.checked && !this.$refs.lxgs8t.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入医院网站',

              duration: 5000
            });
          }, 0)
          arr2.push('id70');
          arr.push(false)
        }
        if (this.$refs.lxgs9.checked && !this.$refs.lxgs9t.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入其它',

              duration: 5000
            });
          }, 0)
          arr2.push('id71');
          arr.push(false)
        }
        console.log(arr2)
        if(arr2.length) {
          window.scrollTo(0, (document.getElementById(arr2[0]).getBoundingClientRect().top + document.documentElement.scrollTop - 100))
        }

        if(arr.length) {
          return false;
        }
        if (this.formData.cxrq) {
          this.formData.cxrq = this.dateFormat(
               "YYYY-mm-dd",
               this.formData.cxrq
          );
        }
        if (this.formData.xwjzrq1) {
          this.formData.xwjzrq1 = this.dateFormat(
               "YYYY-mm-dd",
               this.formData.xwjzrq1
          );
        }
        if (this.formData.xwjzrq2) {
          this.formData.xwjzrq2 = this.dateFormat(
               "YYYY-mm-dd",
               this.formData.xwjzrq2
          );
        }
        try {
          let data = {
            hospital_id: this.id,
            content: this.formData,
            name: this.formData.formName,
            pinyin: this.formPY
          };
          let res = await apis.submitFormData(data);
          if (res.code == 200) {
            // console.log(res)
            this.$message({
              showClose: true,
              message: '提交成功！',
              type: 'success',
              duration: 5000
            });
            let form_id = res.data.id;
            localStorage.setItem("form_id", form_id);
            // console.log(this.type.indexOf('2') > -1)
            if (this.type.indexOf('3') > -1) {
              this.$router.push({ name: 'FormOfTwo', params: { hid: this.id } });
            } else if (this.type.indexOf('4') > -1) {
              this.$router.push({ name: 'FormOfThree', params: { hid: this.id } });
            } else {
              // this.$router.push({
              //   name: "Upload",
              //   params: { form_id: form_id }
              // });
              localStorage.setItem('formLink', 'one')
              this.$router.push({
                path: "/myfile"
              });
            }
          } else {
            this.$message({
              showClose: true,
              message: '提交失败！',

              duration: 5000
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  /*在谷歌下移除input[number]的上下箭头*/
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
  /*在firefox下移除input[number]的上下箭头*/
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .ivu-radio-wrapper {
    height: 40px;
    line-height: 40px;
  }
  // 联系公司
  #demo .LXcompany {
    margin: 0 30px 35px;
  }
  #demo .LXcompany .LXradio /deep/ .ivu-col .label-with-radio-1 {
    display: flex;
    align-items: center;
  }
  #demo .LXcompany .LXradio /deep/ .ivu-col .label-with-radio-1 input[type='checkbox'] {
    vertical-align: middle;
  }
  #demo .LXcompany .LXradio /deep/ .ivu-col .label-with-radio-1 input[type='text'] {
    margin-left: 10px;
  }
  .LXradio {
    margin-bottom: 10px;
  }
  .label-with-radio-1 {
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 40px;
    vertical-align: middle;
    top: -2px;
    margin: 0 10px;
    input[type='checkbox'] {
      position: relative;
      top: 1.5px;
      margin-right: 7px;
    }
  }

  .ivu-radio-wrapper {
    height: 42px;
  }
  .ivu-form .ivu-form-item .ivu-form-item-label,
  .font-label {
    font-size: 16px;
    color: black;
    font-weight: bold;
  }
  .ivu-form-item-label {
    display: inline-block;
    width: 120px;
    font-size: 18px;
    font-weight: bold;
    color: #000;
    line-height: 40px;
  }
  .ivu-form-item-content {
    input[type='text'] {
      height: 40px;
      border: 1px solid #bababa;
      font-size: 16px;
      color: #000;
      text-indent: 8px;
      outline: none;
    }
  }
  .page-form {
    background: #fff;
  }
  .page-wrap {
    width: 970px;
    border: 1px solid #dcdcdc;
    margin: 0 auto 30px;
    padding-bottom: 30px;
  }
  .page-head {
    height: 80px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
    h3 {
      font-size: 30px;
      line-height: 50px;
    }
    p {
      font-size: 18px;
    }
  }
  .page-body {
    background: #fff;
    margin: 0 30px;
  }
  .page-line {
    margin-bottom: 24px;
  }
  .page-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // margin: 0 30px;
  }

  .page-column {
    width: 50%;
    padding-left: 30px;
    input {
      position: relative;
      top: 2px;
      margin-right: 8px;
    }
  }

  .page-cross {
    border-bottom: 1px dashed #e2e2e2;
    padding: 36px 0;
  }
  .page-border {
    border-bottom: 1px dashed #e2e2e2;
    margin-top: 27px;
  }
  .label-with-radio {
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 40px;
    vertical-align: middle;
    top: -2px;
    margin: 0 10px;
    input[type='radio'] {
      vertical-align: middle;
      margin-right: 4px;
    }
    input[type='checkbox'] {
      position: relative;
      top: 1.5px;
      margin-right: 7px;
    }
  }
  .flex {
    width: 100%;
    // flex: 1;
  }
  .form-cell {
    // flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 15px 30px;
    label.form-label {
    }
    label.label-radio {
      display: inline-block;
      width: 80px;
      font-size: 18px;
      color: #000;
      line-height: 40px;
    }
  }
  .form-in-input {
    height: 40px;
    width: 100%;
    border: 1px solid #bababa;
    font-size: 18px;
    color: #000;
    text-indent: 8px;
    outline: none;
  }
  .form-input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    input[type='text'] {
      // flex: 1;
      height: 40px;
      border: 1px solid #bababa;
      font-size: 18px;
      color: #000;
      text-indent: 8px;
      outline: none;
    }
  }
  .page-note {
    font-size: 14px;
    /*color: #999999;*/
    line-height: 30px;
    color: #858585;
    margin: 10px 0 18px 0;
    &:before {
      display: inline-block;
      content: '\25A0';
      color: #ae1e10;
      font-size: 15px;
      margin-right: 10px;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      color: #999999;
      line-height: 30px;
      vertical-align: middle;
    }
    i {
      color: #ae1e10;
    }
  }

  .page-noteS {
    margin: 0px 0px !important;
  }
  .page-title {
    position: relative;
    height: 60px;
    font-size: 22px;
    color: #000;
    line-height: 60px;
    background: #f5f4f4;
    padding-left: 36px;
    font-weight: bold;
    margin-bottom: 13px;
    margin-top: 10px;
    i {
      color: #ae1e10;
    }
    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      display: block;
      width: 10px;
      height: 60px;
      background: #ae1e10;
    }
  }
  .page-stitle {
    font-size: 18px;
    color: #000;
    /*line-height: 20px;*/
  }
  .page-text {
    width: 100%;
    min-height: 130px;
    font-size: 16px;
    color: #000;
    line-height: 24px;
    border: 1px solid #bababa;
    outline: none;
    resize: none;
    padding: 10px;
  }
  .page-state {
    font-size: 14px;
    color: #999;
    line-height: 30px;
  }
  .btn {
    width: 200px;
    height: 50px;
    background: #ac4126;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    border: none;
    border-radius: 4px;
    margin-bottom: 50px;
  }

  ::-webkit-input-placeholder {
    color: #dcdcdc;
    font-size: 14px;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #dcdcdc;
    font-size: 14px;
  }
  　　 :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #dcdcdc;
    font-size: 14px;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #dcdcdc;
    font-size: 14px;
  }

  .first-icon {
    position: relative;
  }

  .span-icon {
    position: absolute;
    left: 12px;
    top: 10px;
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #e9e9e9;
    text-align: center;
    line-height: 20px;
  }

  .radio-size {
    width: 14px;
    height: 14px;
  }

  .radio-sizes {
    position: relative;
    top: 2px;
    margin-right: 8px;
  }

  .page-air {
    // padding-top: 10px;
  }

  .radio-sizeF {
    position: relative;
    top: -1px;
    margin-right: 8px;
  }

  .form-font-size {
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }
  //5.28
  .page-body .label-font /deep/ .ivu-form-item-label {
    width: 112px !important;
  }
  // 客户信息
  .client-body /deep/ .ivu-form-item-content {
    // margin-left: 136px !important;
  }
  .abc /deep/ .ivu-form-item-content {
    margin-left: 130px !important;
  }
  .client-body /deep/ .ivu-form-item-label {
    width: auto !important;
    margin-left: 10px !important;
  }

  .khxxName {
  }
  .khxxName .khxxNameipt1 /deep/ .ivu-form-item .ivu-form-item-content {
    width: 243px;
    margin-left: 60px !important;
  }
  .khxxName .khxxNameipt2 {
    margin: 0 30px;
    width: 243px;
  }
  .khxxName .khxxNameipt3 {
    width: 305px;
  }
  // 性别
  .khxxRadio .khxxRadioipt1 /deep/ .ivu-form-item .ivu-form-item-content {
    margin-left: 10px !important;
    width: 155px;
  }
  .khxxRadio
  .khxxRadioipt2
  /deep/
  .ivu-form-item
  .ivu-form-item-content
  .ivu-col.ivu-col-span-14 {
    // font-size: 18px;
  }
  .khxxtimephone .dateTime /deep/ .ivu-form-item .ivu-form-item-content,
  .phone /deep/ .ivu-form-item .ivu-form-item-content {
    margin-left: 97px !important;
  }
  .khxxtimephone .Email /deep/ .ivu-form-item .ivu-form-item-label {
    width: 95px !important;
  }

  .khxxRess .khxxRessipt /deep/ .ivu-form-item .ivu-form-item-label {
    width: 120px !important;
    text-align: left;
  }
  .khxxRess .khxxRessipt /deep/ .ivu-form-item .ivu-form-item-content {
    margin-left: 130px !important;
  }
  .khxxMuy .Muy /deep/ .ivu-form-item .ivu-form-item-content {
    margin-left: 20px !important;
  }
  .khxxMuy .Muy /deep/ .ivu-form-item .ivu-form-item-content .ivu-radio-group {
    // margin-right: 40px;
    margin: 0 20px;
  }
</style>
<style lang="less">
  .ivu-form .last-from .ivu-form-item-label {
    width: 112px !important;
  }
  .zdm .ivu-form-item-label {
    text-align: left !important;
  }
  .zdm .ivu-form-item-content {
    margin-left: 80px !important;
  }
  .zdm .label-with-radio:first-child {
    margin-left: -16px !important;
    margin-right: 33px !important;
  }
  .zdm .label-with-radio:last-child {
    margin-left: 32px !important;
    margin-right: 0px !important;
  }
  .page-form {
    #demo .ivu-form .one-style .ivu-form-item {
      margin-bottom: 2px !important;
    }
    .khxxtimephone .ivu-col-span-8 {
      &:nth-child(2),
      &:nth-child(3) {
        .ivu-form-item-label {
          margin-left: 64px !important;
        }
      }
    }
    #demo .ivu-form .ivu-form-item-content {
      text-align: left;
    }
    .item-forms-2 .ivu-form-item {
      float: left;
    }
    .item-forms-2 .ivu-form-item .ivu-form-item-content {
      &:nth-child(2) {
        margin-left: 100px !important;
      }
    }
  }
  .frjy .page-line .ivu-col-span-8 .form-font-size {
    margin-left: 20px;
  }
  .frjy .page-line .ivu-col-span-8 .label-with-radio {
    margin: 0 !important;
    margin-left: 20px !important;
  }
  .sex_span {
    width: 50px!important;
  }
  .span_guoji {
    width: 50px!important;
  }
  .span_radio {
    margin-left: 10px!important;
  }
  .shengao{
    margin-left: -60px!important;
  }
  .ivu-diy-input {
    height: 42px;
    border: 1px solid #cacaca;
    font-size: 14px;
    color: #000;
    text-indent: 8px;
    outline: none;
  }
</style>
